var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdditional(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0C8.97231 0 0 8.97231 0 20C0 31.0277 8.97231 40 20 40C31.0277 40 40 31.0277 40 20C40 8.97231 31.0277 0 20 0ZM20 3.07692C29.3646 3.07692 36.9231 10.6354 36.9231 20C36.9231 29.3646 29.3646 36.9231 20 36.9231C10.6354 36.9231 3.07692 29.3646 3.07692 20C3.07692 10.6354 10.6354 3.07692 20 3.07692ZM18.4615 10.7692V18.4615H10.7692V21.5385H18.4615V29.2308H21.5385V21.5385H29.2308V18.4615H21.5385V10.7692H18.4615Z",
    fill: "#020C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdditional);
export default __webpack_public_path__ + "static/media/additional.c127def20017b56899891c014a989025.svg";
export { ForwardRef as ReactComponent };